import { PlusSquareTwoTone, DeleteTwoTone } from "@ant-design/icons";
import { Input, Space } from "antd";

const SelectOptions = ({ options, setOptions = () => {} }) => {
  const addOption = () => {
    const newOption = { key: options.length + 1, value: `Option ${options.length + 1}` };
    setOptions([...options, newOption]);
  };

  const handleInputChange = (key, event) => {
    const newOptions = options.map((option) => {
      if (option.key === key) {
        return { ...option, value: event.target.value };
      }
      return option;
    });

    setOptions(newOptions);
  };

  const handleDelete = (key) => {
    const newOptions = options
      .filter((option) => {
        return option.key !== key;
      })
      .map((option, index) => ({ ...option, key: index + 1 }));
    setOptions(newOptions);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      Enter Options
      <Space direction="vertical">
        <div style={{ display: "flex", flexDirection: "column" }}>
          {options.map((option) => {
            return (
              <Space direction="vertical" key={option.key}>
                <div style={{ display: "flex", gap: "5px" }}>
                  <Input
                    value={option.value}
                    onChange={(event) => handleInputChange(option.key, event)}
                  />
                  <DeleteTwoTone onClick={() => handleDelete(option.key)} />
                </div>
              </Space>
            );
          })}
        </div>
      </Space>
      <PlusSquareTwoTone style={{ marginBottom: "5px", cursor: "pointer" }} onClick={addOption} />
    </div>
  );
};

export default SelectOptions;
